import { render, staticRenderFns } from "./addClaimPartyModal.vue?vue&type=template&id=43d898fe&scoped=true&"
import script from "./addClaimPartyModal.vue?vue&type=script&lang=js&"
export * from "./addClaimPartyModal.vue?vue&type=script&lang=js&"
import style0 from "./addClaimPartyModal.vue?vue&type=style&index=0&id=43d898fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d898fe",
  null
  
)

export default component.exports